module.exports = {"data":{"markdownRemark":{"html":"<p>Pandas are really sweet.</p>\n<p>Here's a video of a panda eating sweets.</p>\n<p><img src=\"/logo.png\" alt=\"logo\"></p>","frontmatter":{"title":"烟台青少年宫"}}},"pathContext":{"slug":"/solutions/烟台青少年宫/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/solutions-烟台青少年宫.json
// module id = 500
// module chunks = 44678134410243